var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.286,
    y: 1.641,
    style: {
      fill: "#4173CD"
    },
    width: 508.71,
    height: 254.36
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M3.286,255.998H512v240.97c0,7.393-5.993,13.388-13.388,13.388H3.286c-7.393,0,0-5.993,0-13.388   V255.998z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 3.286,
    y: 255.998,
    style: {
      fill: "#FFE15A"
    },
    width: 508.71,
    height: 127.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.286,
    y: 383.178,
    style: {
      fill: "#73AF00"
    },
    width: 508.71,
    height: 127.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M430.429,137.891l54.797-9.071l-54.797-9.071l47.155-29.351l-54.099,12.59l32.333-45.162   l-45.162,32.333l12.589-54.099l-29.351,47.155l-9.071-54.797l-9.071,54.797L346.4,36.059l12.589,54.099l-45.162-32.333   l32.333,45.162l-54.099-12.59l47.155,29.351l-54.797,9.071l54.797,9.071l-47.154,29.351l54.098-12.589l-32.332,45.162   l45.162-32.333l-12.589,54.098l29.351-47.154l9.071,54.797l9.071-54.797l29.351,47.154l-12.589-54.098l45.162,32.333   l-32.332-45.162l54.098,12.589L430.429,137.891z M384.822,162.287c-18.484,0-33.468-14.984-33.468-33.468   s14.984-33.468,33.468-33.468s33.468,14.984,33.468,33.468S403.305,162.287,384.822,162.287z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 384.82,
    cy: 128.818,
    r: 25.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/RW.ce0a046472ff48e38c268b934d37294c.svg";
export { ForwardRef as ReactComponent };